module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='52' height='44' viewBox='0 0 52 44'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cpath fill='%23F5F5F5' d='M19.583 0L0 43.484h11.843L31.483 0z'/%3E %3Cpath fill='%23EEE' d='M19.629 0l19.64 43.484h11.843L31.529 0z'/%3E %3C/g%3E %3C/svg%3E\""


//////////////////
// WEBPACK FOOTER
// ./src/assets/url/a-on-white.svg
// module id = ./src/assets/url/a-on-white.svg
// module chunks = 4